<template>
  <div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">文章</li>
    </ol>
    <div class="am-scrollable-horizontal">
      <table class="am-table am-table-hover am-text-nowrap">
        <thead>
        <tr>
          <th>ID</th>
          <th>文章标题</th>
          <th>分类</th>
          <th>标签</th>
          <th>创建时间</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="post in postList">
          <tr>
            <td>{{post.id}}</td>
            <td>
              <router-link :key="post.id" :to="{path:`/edit/post/${post.id}`}">{{post.title}}</router-link>
              <span v-if="post.type===2" class="am-badge am-badge-bilibili am-radius">转载</span>
              <span v-if="post.status===2" class="am-badge am-badge-warning am-radius">隐藏</span>
              <span v-if="post.status===3" class="am-badge am-badge-success am-radius">密码保护</span>
              <span v-if="post.status===4" class="am-badge am-badge-danger am-radius">私密</span>
            </td>
            <td>{{post.typeList.map(e=>e.title).join(", ")}}</td>
            <td>{{post.tagList.map(e=>e.title).join(", ")}}</td>
            <td>{{post.createTime}}</td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">文章</li>
    </ol>
  </div>
</template>

<script>
import { adminPostGetList } from '@/request'
export default {
  name: 'EditPosts',
  data () {
    return {
      postList: []
    }
  },
  mounted () {
    adminPostGetList({ typeData: true, tagData: true }).then(res => {
      this.postList = res
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditPosts.vue